var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Workers50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00695c",
    d: "M36.75,26L36.75,26L33,26.77L29.25,26c0,0-8.25,1.527-8.25,10h24C45,27.559,36.75,26,36.75,26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M33 31L29 26 29 22 37 22 37 26z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M40,15c0-5.879-14-3.828-14,0v3.07c0,3.824,3.133,6.93,7,6.93c3.866,0,7-3.105,7-6.93V15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M28 26.336c-.708.215-2.104.883-3 1.576V35h3V26.336zM41 27.924c-1.172-.846-2.291-1.348-3-1.563V35h3V27.924z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M25 33H41V36H25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5722",
    d: "M39.996 15C39.997 14.978 40 14.957 40 14.934V14c0-3.867-3.134-7-7-7-3.866 0-7 3.133-7 7v.934c0 .023.003.044.003.066H39.996zM24 15H42V17H24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d84315",
    d: "M31 6H35V15H31z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00897b",
    d: "M18.75,32L18.75,32L15,32.77L11.25,32c0,0-8.25,1.527-8.25,10h24C27,33.559,18.75,32,18.75,32"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M15 37L11 32 11 28 19 28 19 32z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M22,21c0-5.879-14-3.828-14,0v3.07C8,27.895,11.133,31,15,31c3.866,0,7-3.105,7-6.93V21z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M10 32.336c-.708.215-2.104.883-3 1.576V41h3V32.336zM23 33.924c-1.172-.846-2.291-1.348-3-1.563V41h3V33.924z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M7 39H23V42H7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M28 33L28 33 25 33 25 33 25 31 25 31 28 31 28 31zM41 33L41 33 38 33 38 33 38 31 38 31 41 31 41 31zM10 39L10 39 7 39 7 39 7 37 7 37 10 37 10 37zM23 39L23 39 20 39 20 39 20 37 20 37 23 37 23 37z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5722",
    d: "M21.996,21C21.997,20.977,22,20.957,22,20.934V20c0-3.867-3.134-7-7-7c-3.866,0-7,3.133-7,7v0.934C8,20.957,8.003,20.977,8.003,21H21.996z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#d84315",
    d: "M13 12H17V21H13z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5722",
    d: "M6 21H24V23H6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M17 24c0 .551.448 1 1 1s1-.449 1-1-.448-1-1-1S17 23.449 17 24M11 24c0 .551.448 1 1 1s1-.449 1-1-.448-1-1-1S11 23.449 11 24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M35 18c0 .551.448 1 1 1s1-.449 1-1c0-.551-.448-1-1-1S35 17.449 35 18M29 18c0 .551.448 1 1 1s1-.449 1-1c0-.551-.448-1-1-1S29 17.449 29 18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Workers50);
export default __webpack_public_path__ + "static/media/icons8-workers-50.bc42a225cf4e827790eb403ef9f83895.svg";
export { ForwardRef as ReactComponent };